import { createTodoCacheLock, TodoDescriptor, TodoDescriptorType } from 'owa-todo-cache';
import { OrderByValue } from 'owa-todo-service';

export const todoCache = createTodoCacheLock();

export function createFolderIdDescriptor(folderId: string): TodoDescriptor {
    return {
        type: TodoDescriptorType.FolderId,
        folderId: folderId,
        orderBy: OrderByValue.OrderDateTime,
    };
}
